import React from "react";

import { ReactComponent as HorizontalLogoEnermatch } from "components/libComponents/enermatch-bg-neg.svg";
import { ReactComponent as LogoEnermatch } from "components/libComponents/enermatch-logo-vertical.svg";

import HorizontalLogoBruky from "components/libComponents/bruky-horizontal.png";
import LogoBruky from "components/libComponents/bruky-logo.png";

type WhitelabelLogoProps = {
  isHorizontal?: Boolean;
};

const WhitelabelLogo = ({ isHorizontal }: WhitelabelLogoProps) => {
  const currentUrl = window.location.hostname;

  const BrukyLogo = () => {
    return isHorizontal ? (
      <img src={HorizontalLogoBruky} alt="Bruky" />
    ) : (
      <img src={LogoBruky} alt="Bruky" />
    );
  };

  const EnermatchLogo = () => {
    return isHorizontal ? (
      <HorizontalLogoEnermatch width={128} />
    ) : (
      <LogoEnermatch />
    );
  };

  switch (currentUrl) {
    case process.env.REACT_APP_URL_BRUKY:
      return <BrukyLogo />;
    default:
      return <EnermatchLogo />;
  }
};

export default WhitelabelLogo;
